import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
export default {
  props: {
    initOperateData: {
      type: Object,
      default: () => {}
    },
    tabVal: {
      type: String,
      default: '2'
    }
  },
  data() {
    return {
      sttFeatureControl: false,
      defaultSwitch: {
        aiSpeech: false,
        voiceCommand: false
      },
      aiSpeechLoading: false,
      aiSpeechSwitchLoading: false,
      langVal: ['en-US'],
      langArray: [{
        label: 'English',
        val: 'en-US'
      }, {
        label: 'Chinese',
        val: 'zh-CN'
      }, {
        label: 'Korean',
        val: 'ko-KR'
      }, {
        label: 'Japanese',
        val: 'ja-JP'
      }, {
        label: 'Spanish',
        val: 'es-ES'
      }, {
        label: 'Portugues',
        val: 'pt-PT'
      }, {
        label: 'French',
        val: 'fr-FR'
      }],
      productionId: '',
      suggestionArray: [{
        label1: 'voiceWord',
        label2: 'action'
      }, {
        label1: 'switchPgm',
        label2: 'setSlotAsPgm'
      }, {
        label1: 'switchPvw',
        label2: 'setSlotAsPvm'
      }, {
        label1: 'cutPvwToPGm',
        label2: 'cutPvwToPGm'
      }, {
        label1: 'curOverlayToPgm',
        label2: 'curOverlayToPgm'
      }],
      ppList: [],
      participantArray: [],
      selectParticipantArray: [],
      selectParticipantTimer: null
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      partyCode: state => state.partyCode
    })
  },
  async mounted() {
    await this.getSttFeature();
    this.$watch('initOperateData.stt', newValue => {
      if (newValue && this.sttFeatureControl) {
        this.defaultSwitch.aiSpeech = true;
      } else {
        this.defaultSwitch.aiSpeech = false;
      }
    }, {
      immediate: true
    });
  },
  watch: {
    'initOperateData.sttLanguage': {
      handler: function (newValue) {
        if (newValue) {
          this.langVal = newValue.languages ? newValue.languages.split(',') : JSON.parse(newValue);
        } else {
          this.langVal = ['en-US'];
        }
      },
      immediate: true
    },
    'initOperateData.voiceCommand': {
      handler: function (newValue) {
        if (newValue) {
          this.defaultSwitch.voiceCommand = true;
        } else {
          this.defaultSwitch.voiceCommand = false;
        }
      },
      immediate: true
    },
    'initOperateData.voiceCommandProduction': {
      handler: async function (newValue) {
        if (newValue) {
          await this.getProducerList();
          this.productionId = Number(newValue);
          this.State.productionId = Number(newValue);
        }
      },
      immediate: true
    },
    tabVal(val) {
      if (val === '7') {
        this.getVoiceCommandList();
      }
    }
  },
  methods: {
    async getSttFeature() {
      try {
        const res = await this.axios.get('/partyline-backend/userSetting/findByKey/stt');
        this.sttFeatureControl = res.data.result && res.data.result !== 'false';
        if (!this.sttFeatureControl) {
          this.defaultSwitch.aiSpeech = false;
        }
      } catch (error) {
        console.error('Failed to fetch STT feature settings:', error);
      }
    },
    scrollToProductionId() {
      this.$nextTick(() => {
        this.$refs.aiSpeechBox.scrollTop = 100;
      });
    },
    getVoiceCommandList() {
      if (!this.State.partyJoinInfo.joinCode) return;
      const params = {
        originRtilCode: this.State.partyJoinInfo.rtilCode,
        annotation: this.State.partyJoinInfo.joinCode,
        keys: ['voiceCommand'],
        marks: this.State.allRtilCodes
      };
      this.axios.post('/partyline-backend/behavior/noLogin/getList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          Object.keys(result).forEach(rtilCode => {
            if (result[rtilCode].voiceCommand === 'true') {
              if (!this.selectParticipantArray.includes(Number(rtilCode))) {
                this.selectParticipantArray.push(Number(rtilCode));
              }
              if (!this.State.voiceCommandList.includes(Number(rtilCode))) {
                this.State.voiceCommandList.push(Number(rtilCode));
              }
            }
          });
        }
      });
    },
    getAddAndRemoveList(hasSelect, currentSelect) {
      const addList = currentSelect.filter(item => !hasSelect.includes(item));
      const removeList = hasSelect.filter(item => !currentSelect.includes(item));
      return {
        addList,
        removeList
      };
    },
    setVoiceCommand(val) {
      if (this.selectParticipantTimer) clearTimeout(this.selectParticipantTimer);
      this.selectParticipantTimer = setTimeout(() => {
        const {
          addList,
          removeList
        } = this.getAddAndRemoveList(this.State.voiceCommandList, val);
        if (addList.length) {
          this.addVoiceCommand(addList);
        }
        if (removeList.length) {
          this.removeVoiceCommand(removeList);
        }
      }, 2000);
    },
    addVoiceCommand(addList) {
      const params = [];
      addList.forEach(rtilCode => {
        const obj = {
          annotation: this.State.partyJoinInfo.joinCode,
          initiator: this.State.partyJoinInfo.rtilCode,
          key: 'voiceCommand',
          mark: rtilCode,
          notify: true,
          value: true
        };
        params.push(obj);
      });
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            message: this.$t('aiSpeech.executeSuccess'),
            type: 'success'
          });
        }
      });
    },
    removeVoiceCommand(removeList) {
      const params = [];
      removeList.forEach(rtilCode => {
        const obj = {
          annotation: this.State.partyJoinInfo.joinCode,
          initiator: this.State.partyJoinInfo.rtilCode,
          key: 'voiceCommand',
          mark: rtilCode,
          notify: true,
          value: false
        };
        params.push(obj);
      });
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            message: this.$t('aiSpeech.executeSuccess'),
            type: 'success'
          });
        }
      });
    },
    controlAISpeech(val) {
      this.aiSpeechLoading = true;
      this.aiSpeechSwitchLoading = true;
      if (val) {
        this.State.sttSwitch = true;
        this.startAISpeech();
      } else {
        this.State.sttSwitch = false;
        this.stopAISpeech();
      }
    },
    startAISpeech() {
      const params = {
        partyCode: this.partyCode,
        languages: this.langVal
      };
      this.axios.post('/partyline-backend/commonParty/startStt', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.defaultSwitch.aiSpeech = true;
        }
        setTimeout(() => {
          this.aiSpeechSwitchLoading = false;
          this.aiSpeechLoading = false;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
        }, 3000);
      });
    },
    stopAISpeech() {
      this.axios.delete(`/partyline-backend/commonParty/stopStt?partyCode=${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          this.defaultSwitch.aiSpeech = false;
          if (this.defaultSwitch.voiceCommand) {
            this.controlAIVoiceCommand(false, 'notChangeAISpeech');
          }
        }
        setTimeout(() => {
          this.aiSpeechSwitchLoading = false;
          this.aiSpeechLoading = false;
          this.$message.success(this.$t('common.stopSuccess'));
        }, 3000);
      });
    },
    controlAIVoiceCommand(val, notChangeAISpeech) {
      const params = {
        buttonType: 14,
        operationType: val ? 1 : 0,
        data: {
          hostRtilCode: this.State.partyJoinInfo.rtilCode
        }
      };
      this.axios.post(`/partyline-backend/partyAction/button?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.aiBotEnable = val;
          this.defaultSwitch.voiceCommand = val;
          this.$message.success(this.$t('commonFunction.operateSuccessful'));
          // voice command 功能依赖于 stt，所以打开 voice command 时，需要打开 stt
          if (!this.defaultSwitch.aiSpeech && !notChangeAISpeech) {
            this.startAISpeech();
          }
        }
      });
    },
    saveProducerId(val) {
      if (!this.State.partyJoinInfo.joinCode) return;
      const params = {
        partyCode: this.State.partyJoinInfo.joinCode,
        productionId: val
      };
      this.axios.post('/partyline-backend/voiceCommand/setProduction', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.$message({
            message: this.$t('aiSpeech.executeSuccess'),
            type: 'success'
          });
        }
      });
    },
    async getProducerList(val) {
      if (!val) return;
      this.ppList = [];
      const params = {
        pageNum: 1,
        pageSize: 100,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      };
      await this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const ppList = res.data.result.pps;
          let hasSelectPPId = false;
          ppList && ppList.forEach(item => {
            item.pageInfo && item.pageInfo.list.forEach(info => {
              this.ppList.push({
                id: info.id,
                name: info.name
              });
              if (this.productionId && info.id === this.productionId) {
                hasSelectPPId = true;
              }
            });
          });
          if (ppList.length === 0 || !hasSelectPPId) {
            this.productionId = '';
            this.State.productionId = '';
          }
        }
      });
    }
  }
};